import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CtaBand({ heading = "Connect With Our Team", subtext = "Learn more about the private investment opportunities, partnerships, and operating capabilities at ZT Health." }) {
  return (
    <section data-testid="cta-band" className="zt-section" style={{ background: "var(--zt-teal)" }}>
      <div className="zt-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-8">
            <p className="text-xs font-bold uppercase tracking-[0.2em] mb-3 text-white/90">
              Investor & Partner Inquiries
            </p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white font-bold leading-tight">
              {heading}
            </h2>
            <p className="text-base md:text-lg text-white/90 mt-4 max-w-2xl">{subtext}</p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Link
              to="/contact"
              data-testid="cta-band-button"
              className="inline-flex items-center gap-3 px-7 py-4 text-sm font-semibold tracking-wide uppercase text-white border-2 border-white hover:bg-white hover:text-teal-700 transition-all"
              style={{ "--tw-text-opacity": "1" }}
            >
              Contact Us <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
